/**
 * useRefreshWalletBalance
 *
 * On-Demand Balance-Refresh via POST /api/v2/wallets/{id}/refresh_balance.
 * Wird serverseitig auf 1 Aufruf pro Wallet/60s rate-limitiert.
 *
 * Bei queued:true wird nach ~2 s die Balance-Query invalidiert,
 * damit der neue Wert nachgeladen wird.
 */
import { useMutation, useQueryClient } from '@tanstack/react-query'
import apiClient from '../../lib/api-client'

export function useRefreshWalletBalance(walletId: number) {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: async () => {
      const result = await apiClient.POST('/api/v2/wallets/{id}/refresh_balance', {
        params: { path: { id: walletId } },
      })
      if (result.error) throw result.error
      return result.data
    },
    onSuccess: (data) => {
      const queued = data?.data?.queued ?? false
      if (queued) {
        // Kurze Verzögerung damit der Worker Zeit hat, die Balance zu aktualisieren
        setTimeout(() => {
          void queryClient.invalidateQueries({
            queryKey: ['wallet', walletId, 'balance'],
          })
        }, 2000)
      }
    },
  })

  return {
    refresh: () => mutation.mutate(),
    isRefreshing: mutation.isPending,
  }
}
